/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRepostedBy.defs'
export { main as default } from './getRepostedBy.defs'
